import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authUserSignal } from '../../../../signals/authSignal';
import { createLogger } from '../../../../utils/logger';

const logger = createLogger('RequiredAuth');

const RequiredAuth = () => {
  const location = useLocation();

  logger.debug(`RequireAuth: ${JSON.stringify(authUserSignal.value)}`)

  return authUserSignal.value?.user ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequiredAuth;
